// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import AppRouter from './router'
import Rest from './services/rest'

import store from './store';
import Firebase from './services/firebase'
import AnonLayout from "./components/layouts/AnonLayout.vue";
import UserLayout from "./components/layouts/UserLayout.vue";
import './assets/vendor/daterangepicker/daterangepicker'
import './assets/vendor/daterangepicker/daterangepicker.css'

import './assets/scripts/custom'

Vue.config.productionTip = false;

Rest.init();
AppRouter.init();
Firebase.init();

const router = AppRouter.router;

Vue.component("anon-layout", AnonLayout);
Vue.component("user-layout", UserLayout);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js